import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-body-container',
  templateUrl: './custom-body-container.component.html',
  styleUrls: ['./custom-body-container.component.scss']
})
export class CustomBodyContainerComponent implements OnInit {
  @Input() fluid = false;

  constructor() { }

  ngOnInit() {
  }

}
